import React, { useState, useEffect } from 'react';
import styles from './OrderModal.module.css';

export const OrderModal = ({ isOpen, onClose, onSubmit, order, viewMode, schema }) => {

	const [price, setPrice] = useState(order ? order.price : '');
	const [status, setStatus] = useState(order ? order.status : '');

	const [fromLogin, setFromLogin] = useState(order ? order.from_shop?.login : '');
	const [fromPassword, setFromPassword] = useState(order ? order.from_shop?.password : '');
	const [fromFA, setFromFA] = useState(order ? order.from_shop?.FA : '');
	const [fromKey, setFromKey] = useState(order ? order.from_shop?.key : '');

	const [inLogin, setInLogin] = useState(order ? order.in_shop?.login : '');
	const [inPassword, setInPassword] = useState(order ? order.in_shop?.password : '');
	const [inEmail, setInEmail] = useState(order ? order.in_shop?.email : '');
	const [inFA, setInFA] = useState(order ? order.in_shop?.FA : '');
	const [inKey, setInKey] = useState(order ? order.in_shop?.key : '');
	const [payId, setPayId] = useState(order ? order.payId : '');

	useEffect(() => {
		if (order) {
			setPrice(order.price);
			setStatus(order.status);
			setPayId(order.payId);
			if (viewMode && !schema) {
				setInLogin(order.in_shop.login);
				setInPassword(order.in_shop.password);
				setInFA(order.in_shop.FA);
				setInKey(order.in_shop.key);
				setInEmail(order.in_shop.email);
			} else if (!schema) {
				setFromLogin(order.from_shop.login);
				setFromPassword(order.from_shop.password);
				setFromFA(order.from_shop.FA);
				setFromKey(order.from_shop.key);
			}
		}
	}, [order, viewMode]);

	// Ранний возврат, если модальное окно закрыто
	if (!isOpen) return null;
	console.log(order)

	const handleSubmit = (e) => {
		e.preventDefault();

		const updatedOrder = {
			...order, 
			price,
			status,
			[viewMode ? 'in_shop' : 'from_shop']: {
				...(viewMode ? order.in_shop : order.from_shop),  // сохраняем остальные поля
				login: viewMode ? inLogin : fromLogin,
				password: viewMode ? inPassword : fromPassword,
				FA: viewMode ? inFA : fromFA,
				key: viewMode ? inKey : fromKey,
			},
		};

		// Отправляем данные через onSubmit
		onSubmit(updatedOrder);
	};
	let arr = []
	if (schema === 'xbox'){
		arr = order?.subscriptions?.map(item => item?.time + 'мес').join(', ')
	}
	if (!order) return null;

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				<button className={styles.modal__closeButton} onClick={onClose}>
					&times;
				</button>

				{viewMode ? (
					<>
						<h2 className={styles.modal__title}>Подробности заказа</h2>
						<div className={styles.modal__detailsList}>
							<div className={styles.modal__detailsItem}>
								<div><strong>ID заказа:</strong> {order.id}</div>
								<div><strong>Цена:</strong> {order.price}</div>
								<div><strong>Статус:</strong> {order.status}</div>
								<div><strong>ID оплаты:</strong> {order.payId}</div>
								<div><strong>ID чека:</strong> {order.checkId}</div>
								<div><strong>Дата создания:</strong> {new Date(order.createdAt).toLocaleString()}</div>
								<div><strong>Пользователь ID:</strong> {order.userId}</div>
								{
									schema ? 
										<div><strong>Названия Товаров:</strong> {order.items?.map(item => item?.title).join(', ') || arr}</div>
									:
									<>
											<div>
												<strong>Названия Товаров:</strong><br />
												{order.item_orders.map(io => {
													if (io.edition) {
														return `${io.edition.item.title} ${io.edition.title} edition`;
													} else if (io.item) {
														return `${io.item.title} Standard edition`;
													} else {
														return null;
													}
												}).filter(Boolean).map((text, index) => (
													<div key={index}>{text}</div>
												))}
											</div>
											<div>
												<strong>Названия Подписок:</strong><br />
												{order.item_orders.map(io => {
													if (io.subscription) {
														return `${io.subscription.title} - ${io.subscription.time} мес`;
													} else {
														return null;
													}
												}).filter(Boolean).map((text, index) => (
													<div key={index}>{text}</div>
												))}
											</div>
									</>
								}
								{
									!schema &&
									<>
										<div> <strong>Информация в магазин:</strong></div>
										<div><strong>Почта для чека:</strong> {inEmail}</div>
										<div><strong>Логин:</strong> {inLogin}</div>
										<div><strong>Пароль:</strong> {inPassword}</div>
										<div><strong>FA:</strong> {inFA}</div>
										<div><strong>Ключ:</strong> {order.in_shop.key}</div>
									</>
								}
								
							</div>
						</div>
					</>
				) : (
					<>
						<h2 className={styles.modal__title}>{order ? 'Изменить заказ' : 'Добавить заказ'}</h2>
						<form className={styles.modal__form} onSubmit={handleSubmit}>
							<div>
								<label>Цена</label>
								<input
									type="number"
									value={price}
									onChange={(e) => setPrice(e.target.value)}
								/>
							</div>
							<div>
								<label>Статус</label>
								<input
									type="text"
									value={status}
									onChange={(e) => setStatus(e.target.value)}
								/>
							</div>

							{
								!schema &&
								<>
										<div>
											<label>Логин (from_shop)</label>
											<input
												type="text"
												value={fromLogin}
												onChange={(e) => setFromLogin(e.target.value)}
											/>
										</div>
										<div>
											<label>Пароль (from_shop)</label>
											<input
												type="text"
												value={fromPassword}
												onChange={(e) => setFromPassword(e.target.value)}
											/>
										</div>
										<div>
											<label>FA (from_shop)</label>
											<input
												type="text"
												value={fromFA}
												onChange={(e) => setFromFA(e.target.value)}
											/>
										</div>
										<div>
											<label>Ключ (from_shop)</label>
											<input
												type="text"
												value={fromKey}
												onChange={(e) => setFromKey(e.target.value)}
											/>
										</div>

								</>
							}

							<div>
								<button type="submit" className={styles.modal__button}>Сохранить</button>
							</div>
						</form>
					</>
				)}
			</div>
		</div>
	);
};
